export default function drawerMenu(){
    const navButton = document.querySelector('#nav-input');
	const navDrawer = document.querySelector('#nav-drawer');
	navButton.addEventListener('click', () => {
		navDrawer.classList.toggle('is-drawerActive');
		//if (navButton.getAttribute('aria-expanded') == 'false') {
			//navButton.setAttribute('aria-expanded', true);
			//} else {
				//navButton.setAttribute('aria-expanded', false);
			//}
	});
}